/**
 * @file EmptyTableRow.js
 * @description A full-width table row that displays a NotFoundBox so a table keeps its headers when it has no results.
 */
import PropTypes from 'prop-types';
import NotFoundBox from './NotFoundBox';
import styles from './EmptyTableRow.module.scss';

function EmptyTableRow({ colSpan, title, description }) {
    return (
        <tr className={styles.emptyRow}>
            <td colSpan={colSpan}>
                <NotFoundBox
                    backgroundColor="#f0f4ff"
                    title={title}
                    description={description}
                />
            </td>
        </tr>
    );
}

EmptyTableRow.propTypes = {
    colSpan: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
};

export default EmptyTableRow;
